import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./components/home/Home";
import "bootstrap/dist/css/bootstrap.min.css";
import Menu from "./components/menu/Menu.jsx";
import Sagalleria from "./components/galleria/Gallery.jsx";
import ScrollToTop from "./ScrollToTop";
import Fuorimenu from "./components/Fuorimenu/Fuorimenu.jsx";
import Login from "./components/server/login/Login.jsx";
import Scelta from "./components/server/scelta/Choose.jsx";
import Importplate from "./components/server/importplate/Importplate.jsx";
import Importphoto from "./components/server/importphoto/Importphoto.jsx";
import Cartamenù from "./components/cartamenu/Cartamenu.jsx";
import "../src/Language/118n.js";
function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/menu" element={<Menu />} />
        <Route path="/galleria" element={<Sagalleria />} />
        <Route path="/fuorimenu" element={<Fuorimenu />} />
        <Route path="/login" element={<Login />} />
        <Route path="/scelta" element={<Scelta />} />
        <Route path="/plate" element={<Importplate />} />
        <Route path="/photo" element={<Importphoto />} />
        <Route path="/carta" element={<Cartamenù />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
